import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectCorporateActionsWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.CORPORATE_ACTIONS];

export const selectCorporateActionsState = (state: State, widgetKey: string) =>
    selectCorporateActionsWidgetsState(state)[widgetKey];
